<template>
  <v-card flat class="pa-4">
    <!-- Snackbar -->
    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <h3 class="mb-3">Configuración de Cabecera del Blog</h3>
    <p class="caption grey--text mb-4">Estos datos se muestran en la parte pública del blog.</p>

    <v-form ref="formSettings" v-model="valid">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field v-model="form.title" label="Título" outlined dense
            :rules="[v => !!v || 'Requerido']" counter="100"></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field v-model="form.icon" label="Ícono (mdi-xxx)" outlined dense
            hint="Ejemplo: mdi-post-outline" persistent-hint>
            <template v-slot:prepend-inner>
              <v-icon small>{{ form.icon || 'mdi-help' }}</v-icon>
            </template>
          </v-text-field>
        </v-col>
      </v-row>

      <v-text-field v-model="form.subtitle" label="Subtítulo" outlined dense
        counter="255" class="mb-1"></v-text-field>

      <v-textarea v-model="form.motivational_msg" label="Mensaje motivacional" outlined dense
        rows="2" counter="500" hint="Se muestra debajo del subtítulo. Puede incluir emojis 🚀"
        persistent-hint class="mb-1"></v-textarea>

      <v-row>
        <v-col cols="12" md="6">
          <p class="caption mb-1">Color de fondo</p>
          <v-menu :close-on-content-click="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined small v-bind="attrs" v-on="on">
                <v-avatar size="20" :color="form.bg_color" class="mr-2"></v-avatar>
                {{ form.bg_color }}
              </v-btn>
            </template>
            <v-color-picker v-model="form.bg_color" hide-inputs show-swatches
              :swatches="swatches" mode="hexa"></v-color-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="6">
          <p class="caption mb-1">Color de texto</p>
          <v-menu :close-on-content-click="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined small v-bind="attrs" v-on="on">
                <v-avatar size="20" :color="form.text_color" class="mr-2"></v-avatar>
                {{ form.text_color }}
              </v-btn>
            </template>
            <v-color-picker v-model="form.text_color" hide-inputs show-swatches
              :swatches="swatchesText" mode="hexa"></v-color-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col cols="12" md="4">
          <v-switch v-model="form.show_greeting" label="Mostrar saludo (Buenos días/tardes/noches)"
            color="teal" hide-details></v-switch>
        </v-col>
        <v-col cols="12" md="4">
          <v-switch v-model="form.show_date" label="Mostrar fecha actual"
            color="teal" hide-details></v-switch>
        </v-col>
        <v-col cols="12" md="4">
          <v-switch v-model="form.active" label="Cabecera personalizada activa"
            color="teal" hide-details></v-switch>
        </v-col>
      </v-row>

      <v-divider class="my-4"></v-divider>

      <!-- Preview -->
      <p class="subtitle-2 grey--text mb-2">Vista previa:</p>
      <v-card outlined class="pa-4 mb-4" :style="{ backgroundColor: form.bg_color }">
        <p v-if="form.show_greeting" class="caption mb-0" :style="{ color: form.text_color }">
          {{ saludo }}
        </p>
        <h2 :style="{ color: form.text_color }">
          <v-icon :color="form.text_color">{{ form.icon || 'mdi-post-outline' }}</v-icon>
          {{ form.title || 'Blog' }}
        </h2>
        <p :style="{ color: form.text_color }" class="mb-1">{{ form.subtitle }}</p>
        <p v-if="form.motivational_msg" class="font-italic caption mb-0"
          :style="{ color: form.text_color }">{{ form.motivational_msg }}</p>
        <p v-if="form.show_date" class="caption mb-0" :style="{ color: form.text_color }">
          {{ fechaActual }}
        </p>
      </v-card>

      <v-btn color="teal" dark :loading="saving" @click="guardar">
        <v-icon left>mdi-content-save</v-icon> Guardar configuración
      </v-btn>
    </v-form>
  </v-card>
</template>

<script>
import forumService from '@/services/forumService.js';

export default {
  name: 'ForumBlogSettingsAdmin',
  data() {
    return {
      valid: true,
      saving: false,
      form: {
        title: 'Blog',
        subtitle: '',
        motivational_msg: '',
        show_date: true,
        show_greeting: true,
        icon: 'mdi-post-outline',
        bg_color: '#FFFFFF',
        text_color: '#00695C',
        banner_url: '',
        active: true
      },
      swatches: [
        ['#FFFFFF', '#F5F5F5', '#ECEFF1'],
        ['#E3F2FD', '#E8F5E9', '#FFF3E0'],
        ['#F3E5F5', '#E0F7FA', '#FFF9C4'],
        ['#FFEBEE', '#E8EAF6', '#F1F8E9']
      ],
      swatchesText: [
        ['#000000', '#212121', '#424242'],
        ['#00695C', '#1B5E20', '#0D47A1'],
        ['#4A148C', '#BF360C', '#1A237E'],
        ['#263238', '#3E2723', '#004D40']
      ],
      mensaje: {
        snackbar: false,
        text: '',
        color: '',
        colorBtn: '',
        timeout: 4000
      }
    };
  },
  computed: {
    saludo() {
      const h = new Date().getHours();
      if (h < 12) return '¡Buenos días!';
      if (h < 18) return '¡Buenas tardes!';
      return '¡Buenas noches!';
    },
    fechaActual() {
      return new Date().toLocaleDateString('es', {
        weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
      });
    }
  },
  mounted() {
    this.cargar();
  },
  methods: {
    cargar() {
      forumService.getBlogSettings().then(res => {
        const data = res.data;
        if (data && data.id) {
          this.form = {
            title: data.title || 'Blog',
            subtitle: data.subtitle || '',
            motivational_msg: data.motivational_msg || '',
            show_date: data.show_date,
            show_greeting: data.show_greeting,
            icon: data.icon || 'mdi-post-outline',
            bg_color: data.bg_color || '#FFFFFF',
            text_color: data.text_color || '#00695C',
            banner_url: data.banner_url || '',
            active: data.active
          };
        }
      });
    },
    guardar() {
      if (!this.$refs.formSettings.validate()) return;
      this.saving = true;
      forumService.updateBlogSettings(this.form).then(() => {
        this.showMsg('Configuración guardada exitosamente', 'success');
      }).catch(err => {
        const errors = err.response && err.response.data && err.response.data.errors;
        this.showMsg(errors ? errors.join(', ') : 'Error al guardar', 'error');
      }).finally(() => {
        this.saving = false;
      });
    },
    showMsg(text, type) {
      this.mensaje.text = text;
      this.mensaje.color = type === 'success' ? 'success' : 'error';
      this.mensaje.colorBtn = type === 'success' ? 'green darken-1' : 'red darken-1';
      this.mensaje.snackbar = true;
    }
  }
};
</script>
